(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let collectionFilterRequest;
    let collectionSearchRequest;
    const allProductsCollectionPath = '/collections/all';

    const syncSearchInputs = query => {
      document.querySelectorAll('.collection-search__input, .header__search-input').forEach(input => {
        input.value = query;
      });
    };

    const activateAllProductsFilter = () => {
      document.querySelectorAll('.collection-sidebar__link').forEach((link, index) => {
        link.classList.toggle('is-active', index === 0);
        link.classList.remove('is-loading');
      });
    };

    const normalizeSearchText = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    const escapeHtml = value => value.replace(/[&<>"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[char]));

    const getCollectionPageUrl = page => {
      const url = new URL(allProductsCollectionPath, window.location.origin);
      const currentSort = new URLSearchParams(window.location.search).get('sort_by');
      if (currentSort) url.searchParams.set('sort_by', currentSort);
      url.searchParams.delete('q');
      if (page > 1) {
        url.searchParams.set('page', page);
      } else {
        url.searchParams.delete('page');
      }
      return url.pathname + url.search;
    };

    const getCollectionSearchUrl = query => {
      const url = new URL(allProductsCollectionPath, window.location.origin);
      const currentSort = new URLSearchParams(window.location.search).get('sort_by');
      if (currentSort) url.searchParams.set('sort_by', currentSort);
      url.searchParams.delete('page');
      url.searchParams.delete('q');
      return query ? url.pathname + url.search + '#q=' + encodeURIComponent(query) : url.pathname + url.search;
    };

    const fetchCollectionDocument = async (url, signal) => {
      const response = await fetch(url, {
        credentials: 'same-origin',
        signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error('Collection search fetch failed');
      const html = await response.text();
      return new DOMParser().parseFromString(html, 'text/html');
    };

    const getCollectionPageCount = doc => Array.from(doc.querySelectorAll('.pagination-btn')).reduce((max, item) => {
      const page = parseInt(item.textContent.trim(), 10);
      return Number.isFinite(page) ? Math.max(max, page) : max;
    }, 1);

    const performCollectionSearch = async (query, pushState = true) => {
      query = query.trim();
      syncSearchInputs(query);
      activateAllProductsFilter();

      if (collectionSearchRequest) collectionSearchRequest.abort();

      if (!query) {
        refreshCollectionMain(getCollectionSearchUrl(''), pushState);
        return;
      }

      const main = document.querySelector('.collection-main');
      const results = main && main.querySelector('[data-collection-results]');
      if (!main || !results) return;

      if (collectionFilterRequest) collectionFilterRequest.abort();
      collectionSearchRequest = new AbortController();

      results.classList.add('is-loading');
      const currentLoader = results.querySelector('.collection-loader');
      if (currentLoader) currentLoader.remove();
      results.insertAdjacentHTML('afterbegin', '<div class="collection-loader" role="status" aria-live="polite"><div class="collection-loader__panel"><span class="collection-loader__spinner" aria-hidden="true"></span><span class="collection-loader__text"><strong>Buscando pruebas</strong><span>Filtrando catálogo</span></span></div></div>');

      try {
        const firstDoc = await fetchCollectionDocument(getCollectionPageUrl(1), collectionSearchRequest.signal);
        const pageCount = getCollectionPageCount(firstDoc);
        const docs = [firstDoc];

        if (pageCount > 1) {
          const rest = await Promise.all(Array.from({ length: pageCount - 1 }, (_, index) => fetchCollectionDocument(getCollectionPageUrl(index + 2), collectionSearchRequest.signal)));
          docs.push(...rest);
        }

        const needle = normalizeSearchText(query);
        const matches = docs.flatMap(doc => Array.from(doc.querySelectorAll('[data-collection-results] .product-card')))
          .filter(card => normalizeSearchText(card.textContent).includes(needle));

        if (matches.length) {
          results.innerHTML = '<div class="collection-grid">' + matches.map(card => card.outerHTML).join('') + '</div>';
        } else {
          results.innerHTML = '<div class="collection-empty"><div class="collection-empty__icon"><svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg></div><h2>No se encontraron pruebas</h2><p>No hay resultados para "' + escapeHtml(query) + '" en esta colección.</p></div>';
        }

        results.classList.remove('is-loading');
        results.classList.add('is-entering');
        window.setTimeout(() => results.classList.remove('is-entering'), 800);
        if (pushState) window.history.pushState({}, '', getCollectionSearchUrl(query));
        initCollectionGrid(results);
      } catch (error) {
        if (error.name === 'AbortError') return;
        results.classList.remove('is-loading');
      }
    };

    const withCurrentSort = url => {
      const nextUrl = new URL(url, window.location.origin);
      const currentSort = new URLSearchParams(window.location.search).get('sort_by');
      if (currentSort) nextUrl.searchParams.set('sort_by', currentSort);
      return nextUrl.pathname + nextUrl.search;
    };

    const refreshCollectionMain = async (url, pushState = true) => {
      const main = document.querySelector('.collection-main');
      if (!main) {
        window.location.href = url;
        return;
      }

      const results = main.querySelector('[data-collection-results]') || main;
      if (collectionFilterRequest) collectionFilterRequest.abort();
      collectionFilterRequest = new AbortController();
      results.classList.add('is-loading');
      const currentLoader = results.querySelector('.collection-loader');
      if (currentLoader) currentLoader.remove();
      results.insertAdjacentHTML('afterbegin', '<div class="collection-loader" role="status" aria-live="polite"><div class="collection-loader__panel"><span class="collection-loader__spinner" aria-hidden="true"></span><span class="collection-loader__text"><strong>Actualizando catálogo</strong><span>Cargando productos</span></span></div></div>');

      try {
        const response = await fetch(url, {
          credentials: 'same-origin',
          signal: collectionFilterRequest.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error('Collection fetch failed');

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextMain = doc.querySelector('.collection-main');
        if (!nextMain) throw new Error('Collection content missing');

        main.innerHTML = nextMain.innerHTML;
        const nextResults = main.querySelector('[data-collection-results]');
        if (nextResults) {
          nextResults.classList.add('is-entering');
          window.setTimeout(() => nextResults.classList.remove('is-entering'), 800);
        }
        if (pushState) window.history.pushState({}, '', url);
        initCollectionControls(main);
      } catch (error) {
        if (error.name === 'AbortError') return;
        window.location.href = url;
      }
    };

    const initCollectionFilters = (root = document) => {
      root.querySelectorAll('[data-collection-filter]').forEach(dropdown => {
        if (dropdown.dataset.collectionFilterReady === 'true') return;
        dropdown.dataset.collectionFilterReady = 'true';

        const trigger = dropdown.querySelector('.collection-filter-trigger');
        const triggerValue = dropdown.querySelector('.collection-filter-trigger__value');
        const menu = dropdown.querySelector('.collection-filter-menu');
        const close = dropdown.querySelector('.collection-filter-menu__close');
        const apply = dropdown.querySelector('.collection-filter-apply');

        const setOpen = open => {
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
          menu.hidden = !open;
        };

        trigger.addEventListener('click', () => {
          setOpen(menu.hidden);
        });

        close.addEventListener('click', () => setOpen(false));

        dropdown.querySelectorAll('.collection-filter-option input').forEach(input => {
          input.addEventListener('change', () => {
            dropdown.querySelectorAll('.collection-filter-option').forEach(option => {
              option.classList.toggle('is-active', option.contains(input));
            });

            const label = input.closest('.collection-filter-option');
            const text = label && label.querySelector('.collection-filter-option__text');
            if (triggerValue && text) triggerValue.textContent = text.textContent.trim();
          });
        });

        apply.addEventListener('click', () => {
          const selected = dropdown.querySelector('.collection-filter-option input:checked');
          if (!selected || !selected.value) return;
          setOpen(false);
          refreshCollectionMain(withCurrentSort(selected.value));
        });

        document.addEventListener('click', event => {
          if (!dropdown.contains(event.target)) setOpen(false);
        });

        document.addEventListener('keydown', event => {
          if (event.key === 'Escape') setOpen(false);
        });
      });
    };

    const initCollectionSort = (root = document) => {
      root.querySelectorAll('[data-collection-sort]').forEach(dropdown => {
        if (dropdown.dataset.collectionSortReady === 'true') return;
        dropdown.dataset.collectionSortReady = 'true';

        const trigger = dropdown.querySelector('.collection-sort-trigger');
        const triggerValue = dropdown.querySelector('.collection-sort-trigger__value');
        const menu = dropdown.querySelector('.collection-sort-menu');

        const setOpen = open => {
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
          menu.hidden = !open;
        };

        trigger.addEventListener('click', () => {
          setOpen(menu.hidden);
        });

        dropdown.querySelectorAll('.collection-sort-option input').forEach(input => {
          input.addEventListener('change', () => {
            dropdown.querySelectorAll('.collection-sort-option').forEach(option => {
              option.classList.toggle('is-active', option.contains(input));
            });

            const label = input.closest('.collection-sort-option');
            const text = label && label.querySelector('.collection-sort-option__text');
            if (triggerValue && text) triggerValue.textContent = text.textContent.trim();
            setOpen(false);
            if (input.value) refreshCollectionMain(input.value);
          });
        });

        document.addEventListener('click', event => {
          if (!dropdown.contains(event.target)) setOpen(false);
        });

        document.addEventListener('keydown', event => {
          if (event.key === 'Escape') setOpen(false);
        });
      });
    };

    const initSidebarFilters = (root = document) => {
      root.querySelectorAll('[data-sidebar-filter]').forEach(sidebar => {
        if (sidebar.dataset.sidebarFilterReady === 'true') return;
        sidebar.dataset.sidebarFilterReady = 'true';

        sidebar.addEventListener('click', event => {
          const link = event.target.closest('.collection-sidebar__link');
          if (!link || !link.href) return;
          event.preventDefault();

          sidebar.querySelectorAll('.collection-sidebar__link').forEach(item => {
            item.classList.toggle('is-active', item === link);
            item.classList.remove('is-loading');
          });
          link.classList.add('is-loading');
          refreshCollectionMain(withCurrentSort(link.href));
        });
      });
    };

    const initCollectionSearch = (root = document) => {
      root.querySelectorAll('[data-collection-search]').forEach(form => {
        if (form.dataset.collectionSearchReady === 'true') return;
        form.dataset.collectionSearchReady = 'true';

        const input = form.querySelector('.collection-search__input');
        const expand = () => {
          form.classList.add('is-expanded');
          input.focus();
        };
        const collapse = () => {
          if (!input.value.trim()) form.classList.remove('is-expanded');
        };

        form.addEventListener('click', event => {
          if (!form.classList.contains('is-expanded')) {
            event.preventDefault();
            expand();
          }
        });

        input.addEventListener('focus', expand);
        input.addEventListener('blur', collapse);

        let searchTypingTimer;
        input.addEventListener('input', () => {
          window.clearTimeout(searchTypingTimer);
          searchTypingTimer = window.setTimeout(() => {
            performCollectionSearch(input.value);
          }, 300);
        });

        form.addEventListener('submit', event => {
          if (!form.classList.contains('is-expanded') || !input.value.trim()) {
            event.preventDefault();
            expand();
            return;
          }

          event.preventDefault();
          performCollectionSearch(input.value);
        });
      });
    };

    const initCollectionGrid = (root = document) => {
      root.querySelectorAll('.collection-grid').forEach(grid => {
        if (grid.dataset.collectionGridReady === 'true') return;
        grid.dataset.collectionGridReady = 'true';

    const cartState = new Map();

    const setHeaderCartCount = count => {
      const cartBtn = document.querySelector('.header__cart-btn');
      if (!cartBtn) return;
      let badge = cartBtn.querySelector('.header__cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'header__cart-count';
          cartBtn.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    };

    const changeHeaderCartCount = amount => {
      const badge = document.querySelector('.header__cart-count');
      const current = badge ? parseInt(badge.textContent, 10) || 0 : 0;
      setHeaderCartCount(Math.max(current + amount, 0));
    };

    const setCardQuantity = (card, quantity) => {
      const form = card.querySelector('.product-card__cta-form');
      const controls = card.querySelector('.product-card__qty-controls');
      const countEl = controls.querySelector('.qty-count');
      const cartIcon = form.querySelector('.cart-icon');
      const checkIcon = form.querySelector('.check-icon');

      countEl.textContent = quantity;

      if (quantity > 0) {
        controls.dataset.variantId = form.dataset.variantId;
        form.classList.add('is-hidden');
        controls.classList.add('is-visible');
        cartIcon.classList.add('is-hidden');
        checkIcon.classList.add('is-visible');
      } else {
        controls.classList.remove('is-visible');
        form.classList.remove('is-hidden');
        cartIcon.classList.remove('is-hidden');
        checkIcon.classList.remove('is-visible');
      }
    };

    const postCart = (url, data) => {
      const body = new FormData();
      Object.entries(data).forEach(([key, value]) => body.append(key, value));
      return fetch(url, {
        method: 'POST',
        body,
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      });
    };

    const getCart = async () => {
      const res = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      });
      if (!res.ok) throw new Error('Cart fetch failed');
      return res.json();
    };

    window.syncCardsFromCart = function(cart) {
      var quantities = new Map();

      cart.items.forEach(item => {
        var variantId = String(item.variant_id);
        var current = quantities.get(variantId) || 0;
        quantities.set(variantId, current + item.quantity);
      });

      grid.querySelectorAll('.product-card').forEach(card => {
        var form = card.querySelector('.product-card__cta-form');
        if (!form) return;
        var variantId = String(form.dataset.variantId);
        var quantity = quantities.get(variantId) || 0;
        cartState.set(variantId, { targetQty: quantity, sentQty: quantity, processing: false });
        setCardQuantity(card, quantity);
      });

      setHeaderCartCount(cart.item_count);
    };

    var syncFromCart = async function() {
      try {
        window.syncCardsFromCart(await getCart());
      } catch(e) { }
    };

    const queueCartChange = (variantId, targetQty) => {
      const id = String(variantId);
      const state = cartState.get(id) || { targetQty: 0, sentQty: 0, processing: false };
      state.targetQty = targetQty;
      cartState.set(id, state);

      if (state.processing) return;

      state.processing = true;

      (async () => {
        while (state.sentQty !== state.targetQty) {
          const nextQty = state.targetQty;
          const res = await postCart('/cart/update.js', { [`updates[${id}]`]: nextQty });
          if (!res.ok) throw new Error('Cart update failed');
          state.sentQty = nextQty;
        }
      })()
        .catch(syncFromCart)
        .finally(() => {
          state.processing = false;
          if (window.updateCartDropdown) window.updateCartDropdown();
        });
    };

    syncFromCart();

    grid.addEventListener('click', async e => {
      const addButton = e.target.closest('.product-card__add-btn');
      if (addButton) {
        e.preventDefault();
        const form = addButton.closest('.product-card__cta-form');
        const card = form.closest('.product-card');
        if (addButton.disabled) return;

        setCardQuantity(card, 1);
        changeHeaderCartCount(1);
        queueCartChange(form.dataset.variantId, 1);
        return;
      }

      const minus = e.target.closest('.qty-minus');
      const plus = e.target.closest('.qty-plus');
      if (minus || plus) {
        const controls = (minus || plus).closest('.product-card__qty-controls');
        const card = controls.closest('.product-card');
        const form = card.querySelector('.product-card__cta-form');
        const countEl = controls.querySelector('.qty-count');
        const currentQty = parseInt(countEl.textContent, 10) || 1;
        const qty = minus ? currentQty - 1 : currentQty + 1;
        const variantId = controls.dataset.variantId || form.dataset.variantId;
        const nextQty = Math.max(qty, 0);

        setCardQuantity(card, nextQty);
        changeHeaderCartCount(nextQty - currentQty);
        queueCartChange(variantId, nextQty);
        return;
      }

      if (e.target.closest('a, button, form, input, select, textarea, label, .product-card__actions')) return;

      const card = e.target.closest('.product-card');
      if (card && card.dataset.productUrl) {
        window.location.href = card.dataset.productUrl;
      }
    });
      });
    };

    const initCollectionView = (root = document) => {
      root.querySelectorAll('[data-collection-view]').forEach(toggle => {
        if (toggle.dataset.collectionViewReady === 'true') return;
        toggle.dataset.collectionViewReady = 'true';

        toggle.addEventListener('click', event => {
          const button = event.target.closest('[data-view]');
          if (!button) return;

          const grid = document.querySelector('.collection-grid');
          if (!grid) return;

          const isList = button.dataset.view === 'list';
          grid.classList.toggle('collection-grid--list', isList);
          toggle.querySelectorAll('[data-view]').forEach(viewButton => {
            const isActive = viewButton === button;
            viewButton.classList.toggle('is-active', isActive);
            viewButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        });
      });
    };

    const initCollectionControls = (root = document) => {
      initCollectionFilters(root);
      initSidebarFilters(root);
      initCollectionSearch(root);
      initCollectionSort(root);
      initCollectionGrid(root);
      initCollectionView(root);
    };

    initCollectionControls();

    const getHashQuery = () => window.location.hash.startsWith('#q=') ? decodeURIComponent(window.location.hash.slice(3)) : '';
    const initialQuery = getHashQuery();
    if (initialQuery) performCollectionSearch(initialQuery, false);

    window.addEventListener('popstate', () => {
      const query = getHashQuery();
      if (query) {
        performCollectionSearch(query, false);
      } else {
        refreshCollectionMain(window.location.href, false);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-login"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var btn = document.querySelector('[data-toggle-pwd]');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var input = document.getElementById('customer-password');
      var isHidden = input.type === 'password';
      input.type = isHidden ? 'text' : 'password';
      btn.querySelector('.auth-eye--show').style.display = isHidden ? 'none' : '';
      btn.querySelector('.auth-eye--hide').style.display = isHidden ? '' : 'none';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-register"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var btn = document.querySelector('[data-toggle-pwd]');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var input = document.getElementById('reg-password');
      var isHidden = input.type === 'password';
      input.type = isHidden ? 'text' : 'password';
      btn.querySelector('.auth-eye--show').style.display = isHidden ? 'none' : '';
      btn.querySelector('.auth-eye--hide').style.display = isHidden ? '' : 'none';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.querySelector('[data-header]');
    var burger = document.querySelector('[data-burger]');
    var menu = document.querySelector('[data-mobile-menu]');
    var allProductsUrl = header ? header.dataset.allProductsUrl : '/collections/all';
    var searchPageUrl = header ? header.dataset.searchUrl : '/search';
    var cartUrl = header ? header.dataset.cartUrl : '/cart';
    var checkoutUrl = header && header.dataset.checkoutUrl ? header.dataset.checkoutUrl : '/checkout';
    var cartClearUrl = header ? header.dataset.cartClearUrl : '/cart/clear';
    var cartChangeUrl = header ? header.dataset.cartChangeUrl : '/cart/change';
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          header.classList.toggle('header--scrolled', window.scrollY > 10);
          ticking = false;
        });
        ticking = true;
      }
    });
    if (burger && menu) {
      burger.addEventListener('click', function() {
        var open = menu.classList.toggle('header__mobile-menu--open');
        burger.classList.toggle('header__burger--active', open);
        burger.setAttribute('aria-expanded', open);
      });
    }
    var searchTrigger = document.querySelector('[data-mobile-search-trigger]');
    if (searchTrigger && menu) {
      searchTrigger.addEventListener('click', function() {
        menu.classList.add('header__mobile-menu--open');
        if (burger) {
          burger.classList.add('header__burger--active');
          burger.setAttribute('aria-expanded', 'true');
        }
        var mobileInput = menu.querySelector('.header__search-input');
        if (mobileInput) {
          setTimeout(function() { mobileInput.focus(); }, 150);
        }
      });
    }

    var headerSearchCache = null;
    var headerSearchTimer;
    var headerSearchController;

    function escapeSearchHtml(value) {
      return String(value || '').replace(/[&<>"]/g, function(char) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[char];
      });
    }

    function normalizeSearchText(value) {
      return String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    function collectionPageUrl(page) {
      return page > 1 ? allProductsUrl + '?page=' + page : allProductsUrl;
    }

    function searchUrl(query) {
      return searchPageUrl + '?type=product&q=' + encodeURIComponent(query.trim());
    }

    function setHeaderSearchInputs(query) {
      document.querySelectorAll('.header__search-input').forEach(function(input) {
        if (input.value !== query) input.value = query;
      });
    }

    function setHeaderSearchDropdown(form, html) {
      var dropdown = form.querySelector('[data-header-search-results]');
      if (!dropdown) return;
      dropdown.innerHTML = html;
      dropdown.hidden = false;
    }

    function hideHeaderSearchDropdowns() {
      document.querySelectorAll('[data-header-search-results]').forEach(function(dropdown) {
        dropdown.hidden = true;
        dropdown.innerHTML = '';
      });
    }

    function getHeaderSearchPageCount(doc) {
      return Array.from(doc.querySelectorAll('.pagination-btn')).reduce(function(max, item) {
        var page = parseInt(item.textContent.trim(), 10);
        return Number.isFinite(page) ? Math.max(max, page) : max;
      }, 1);
    }

    function readHeaderSearchCard(card) {
      var titleLink = card.querySelector('.product-card__title a') || card.querySelector('.product-card__image-link');
      var image = card.querySelector('.product-card__image');
      var prices = card.querySelectorAll('.product-card__price');
      var vendor = card.querySelector('.product-card__vendor');
      return {
        url: titleLink ? titleLink.getAttribute('href') : '#',
        title: titleLink ? titleLink.textContent.trim() : '',
        image: image ? image.getAttribute('src') : '',
        alt: image ? image.getAttribute('alt') : '',
        vendor: vendor ? vendor.textContent.trim() : '',
        price: prices.length ? prices[prices.length - 1].textContent.trim() : '',
        text: card.textContent
      };
    }

    function fetchHeaderSearchProducts() {
      if (headerSearchCache) return Promise.resolve(headerSearchCache);
      if (headerSearchController) headerSearchController.abort();
      headerSearchController = new AbortController();

      return fetch(collectionPageUrl(1), {
        credentials: 'same-origin',
        signal: headerSearchController.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function(response) {
          if (!response.ok) throw new Error('Header search fetch failed');
          return response.text();
        })
        .then(function(html) {
          var firstDoc = new DOMParser().parseFromString(html, 'text/html');
          var pageCount = getHeaderSearchPageCount(firstDoc);
          var docs = [firstDoc];
          var requests = [];

          for (var page = 2; page <= pageCount; page++) {
            requests.push(fetch(collectionPageUrl(page), {
              credentials: 'same-origin',
              signal: headerSearchController.signal,
              headers: { 'X-Requested-With': 'XMLHttpRequest' }
            }).then(function(response) { return response.text(); }).then(function(pageHtml) {
              return new DOMParser().parseFromString(pageHtml, 'text/html');
            }));
          }

          return Promise.all(requests).then(function(restDocs) {
            docs = docs.concat(restDocs);
            headerSearchCache = docs.flatMap(function(doc) {
              return Array.from(doc.querySelectorAll('[data-collection-results] .product-card')).map(readHeaderSearchCard);
            }).filter(function(item) { return item.title; });
            return headerSearchCache;
          });
        });
    }

    function renderHeaderSearchResults(form, query, products) {
      var needle = normalizeSearchText(query);
      var matches = products.filter(function(item) {
        return normalizeSearchText(item.text).indexOf(needle) !== -1;
      }).slice(0, 5);

      if (!matches.length) {
        setHeaderSearchDropdown(form, '<p class="header-search-results__heading">Búsquedas sugeridas</p><p class="header-search-results__status">No hay resultados para "' + escapeSearchHtml(query) + '".</p><a class="header-search-results__footer" href="' + searchUrl(query) + '"><span aria-hidden="true">⌕</span> Ver catálogo completo</a>');
        return;
      }

      var html = '<p class="header-search-results__heading">Búsquedas sugeridas</p>' + matches.map(function(item) {
        var image = item.image
          ? '<img class="header-search-results__image" src="' + escapeSearchHtml(item.image) + '" alt="' + escapeSearchHtml(item.alt || item.title) + '" width="62" height="62" loading="lazy">'
          : '<span class="header-search-results__placeholder" aria-hidden="true">⌕</span>';
        return '<a class="header-search-results__item" href="' + escapeSearchHtml(item.url) + '">'
          + image
          + '<span class="header-search-results__meta">'
          + '<span class="header-search-results__title">' + escapeSearchHtml(item.title) + '</span>'
          + (item.vendor ? '<span class="header-search-results__vendor">' + escapeSearchHtml(item.vendor) + '</span>' : '')
          + (item.price ? '<span class="header-search-results__price">' + escapeSearchHtml(item.price) + '</span>' : '')
          + '</span><span class="header-search-results__arrow" aria-hidden="true">›</span></a>';
      }).join('');

      html += '<a class="header-search-results__footer" href="' + searchUrl(query) + '"><span aria-hidden="true">⌕</span> Ver todos los resultados</a>';
      setHeaderSearchDropdown(form, html);
    }

    document.querySelectorAll('.header__search-form').forEach(function(form) {
      var input = form.querySelector('.header__search-input');
      if (!input) return;

      input.addEventListener('input', function() {
        var query = input.value.trim();
        window.clearTimeout(headerSearchTimer);
        setHeaderSearchInputs(input.value);

        if (!query) {
          hideHeaderSearchDropdowns();
          return;
        }

        setHeaderSearchDropdown(form, '<p class="header-search-results__heading">Búsquedas sugeridas</p><p class="header-search-results__status">Buscando...</p>');
        headerSearchTimer = window.setTimeout(function() {
          fetchHeaderSearchProducts()
            .then(function(products) { renderHeaderSearchResults(form, query, products); })
            .catch(function(error) {
              if (error.name === 'AbortError') return;
              setHeaderSearchDropdown(form, '<p class="header-search-results__status">No se pudo cargar la búsqueda.</p>');
            });
        }, 250);
      });
    });

    document.addEventListener('click', function(event) {
      if (!event.target.closest('.header__search-form')) hideHeaderSearchDropdowns();
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') hideHeaderSearchDropdowns();
    });

    // AJAX Cart Logic
    var cartTrigger = document.getElementById('cart-icon-trigger');
    var cartDropdown = document.getElementById('cart-dropdown');
    
    if (cartTrigger && cartDropdown) {
      cartTrigger.addEventListener('click', function(e) {
        if (window.innerWidth > 768) {
          e.preventDefault();
          cartDropdown.classList.toggle('is-active');
        }
      });
      
      document.addEventListener('click', function(e) {
        if (!cartTrigger.contains(e.target) && !cartDropdown.contains(e.target)) {
          cartDropdown.classList.remove('is-active');
        }
      });
    }

    function formatMoney(cents) {
      return '$\u00a0' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function renderDropdown(cart) {
      if (!cartDropdown) return;
      
      // Update badge
      var countWrapper = document.querySelector('.header__cart-btn');
      var oldCount = document.querySelector('.header__cart-count');
      if (cart.item_count > 0) {
        if (oldCount) {
          oldCount.textContent = cart.item_count;
        } else if (countWrapper) {
          countWrapper.insertAdjacentHTML('beforeend', '<span class="header__cart-count">' + cart.item_count + '</span>');
        }
      } else if (oldCount) {
        oldCount.remove();
      }

      // Build inner HTML
      var inner;
      if (cart.item_count === 0) {
        inner = '<div class="cart-dropdown__empty">'
          + '<p style="margin:0 0 1rem 0;font-weight:600;text-align:center;">Tu carrito está vacío</p>'
          + '<a href="' + allProductsUrl + '" class="cart-dropdown__btn-checkout" style="text-decoration:none;display:block;text-align:center;">Ver productos</a>'
          + '</div>';
      } else {
        var itemsHtml = '<div class="cart-dropdown__items">';
        cart.items.forEach(function(item, index) {
          var img = item.featured_image && item.featured_image.url
            ? item.featured_image.url + '&width=100'
            : '';
          itemsHtml += '<div class="cart-dropdown__item">'
            + '<div class="cart-dropdown__item-media">'
            + (img ? '<img src="' + img + '" alt="' + item.title + '" width="60" height="60" style="object-fit:cover;border-radius:8px;">' : '')
            + '</div>'
            + '<div class="cart-dropdown__item-details">'
            + '<a href="' + item.url + '" class="cart-dropdown__item-title">' + item.product_title + '</a>'
            + '<div class="cart-dropdown__item-price">' + formatMoney(item.final_line_price) + '</div>'
            + '<div class="quantity-selector cart-dropdown__quantity">'
            + '<button type="button" class="quantity-btn minus" data-action="decrease" data-line="' + (index + 1) + '" data-key="' + item.key + '">-</button>'
            + '<input type="number" value="' + item.quantity + '" data-line="' + (index + 1) + '" data-key="' + item.key + '" readonly>'
            + '<button type="button" class="quantity-btn plus" data-action="increase" data-line="' + (index + 1) + '" data-key="' + item.key + '">+</button>'
            + '</div></div>'
            + '<button type="button" class="cart-dropdown__item-remove" data-key="' + item.key + '">'
            + '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"></path><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>'
            + '</button></div>';
        });
        itemsHtml += '</div>';

        var footer = '<div class="cart-dropdown__footer">'
          + '<div class="cart-dropdown__subtotal"><span>Subtotal</span><strong>' + formatMoney(cart.total_price) + '</strong></div>'
          + '<div class="cart-dropdown__buttons">'
          + '<a href="' + cartUrl + '" class="cart-dropdown__btn-cart">Ir al carrito</a>'
          + '<a href="' + checkoutUrl + '" class="cart-dropdown__btn-checkout">Proceder al pago</a>'
          + '</div></div>';

        inner = itemsHtml + footer;
      }

      cartDropdown.querySelector('.cart-dropdown__inner').innerHTML = inner;

      // Sync collection cards if present on page
      if (typeof window.syncCardsFromCart === 'function') {
        window.syncCardsFromCart(cart);
      }

      if (!cartDropdown.classList.contains('is-active')) {
        cartDropdown.classList.add('is-active');
      }
    }

    window.updateCartDropdown = function() {
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function(res) { return res.json(); })
        .then(renderDropdown);
    };

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.quantity-btn');
      var removeBtn = e.target.closest('.cart-dropdown__item-remove');
      var clearBtn = e.target.closest('.cart-dropdown__action-clear');
      
      if (btn && btn.closest('#cart-dropdown')) {
        e.preventDefault();
        var input = btn.parentElement.querySelector('input');
        var key = btn.getAttribute('data-key');
        var line = parseInt(btn.getAttribute('data-line'), 10);
        var action = btn.getAttribute('data-action');
        var val = parseInt(input.value, 10) || 0;

        if (action === 'decrease') val = Math.max(0, val - 1);
        if (action === 'increase') val++;
        if (!key) return;

        btn.disabled = true;

        var formData = new FormData();
        formData.append('updates[' + key + ']', val);

        var updateByLine = function() {
          return fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ line: line, quantity: val })
          }).then(function(res) {
            if (!res.ok) throw new Error('Cart change failed');
            return res.json();
          });
        };
        
        fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function(res) {
            if (!res.ok) throw new Error('Cart update failed');
            return res.json();
          })
          .then(function(cart) {
            var updated = val === 0 || cart.items.some(function(item) {
              return item.key === key && item.quantity === val;
            });
            if (!updated && !isNaN(line)) return updateByLine();
            return cart;
          })
          .catch(function() {
            if (!isNaN(line)) return updateByLine();
            throw new Error('Cart update failed');
          })
          .then(renderDropdown)
          .catch(window.updateCartDropdown)
          .finally(function() { btn.disabled = false; });
      }
      
      if (removeBtn && removeBtn.closest('#cart-dropdown')) {
        var key = removeBtn.getAttribute('data-key');
        fetch(cartChangeUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(res => res.json()).then(window.updateCartDropdown);
      }
      
      if (clearBtn && clearBtn.closest('#cart-dropdown')) {
        fetch(cartClearUrl + '.js', {
          method: 'POST'
        }).then(res => res.json()).then(window.updateCartDropdown);
      }
    });

    document.addEventListener('submit', function(e) {
      if (e.target.matches('form[action^="/cart/add"]')) {
        var form = e.target;
        var submitBtn = e.submitter || (document.activeElement && document.activeElement.matches('[type="submit"]') ? document.activeElement : form.querySelector('[type="submit"]'));
        if (submitBtn && submitBtn.name === 'return_to') return;
        e.preventDefault();
        var formData = new FormData(form);
        var originalText = submitBtn ? submitBtn.innerText : '';
        if(submitBtn) submitBtn.innerText = 'Agregando...';
        
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        }).then(res => res.json()).then(data => {
          window.updateCartDropdown();
          if(submitBtn) submitBtn.innerText = originalText;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    if (event.target.closest('a, button, form, input, select, textarea, label')) return;

    var card = event.target.closest('.showcase-card[data-product-url]');
    if (card) window.location.href = card.dataset.productUrl;
  });

  } catch(e) { console.error(e); }
})();
})();
